// extracted by mini-css-extract-plugin
export default {"container":"---------packages-corgi-x-src-components-ContentLoader-ContentLoader-module__container"};